module.exports = __webpack_public_path__ + "img/undraw_voting_nvu7.b8496620.png";